import { useQuery } from "@tanstack/react-query";
import { getConnectorConfigurations } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const getConnectorConfigurationsQueryKey = (
	offset: number,
	limit: number,
) => ["CONNECTOR_CONFIGURATIONS_QUERY", offset, limit];

export function useConnectorConfigurationsQuery() {
	return useQuery({
		queryKey: [getConnectorConfigurationsQueryKey(0, 100)],
		queryFn: processResponse(() => getConnectorConfigurations(0, 100)),
	});
}
